import AgendaPage from '../../agenda/pages/AgendaPage';
import CmsPage from '../../cms/CmsPage';
import RdvOffersScreen from '../../components/rdv/RdvOffersScreen';
import RdvScreen from '../../components/rdv/RdvScreen';
import DataPage from '../../core-data/DataPage';
import ExhibitorPage from '../../exhibitors/pages/ExhibitorPage';
import ExhibitorsPage from '../../exhibitors/pages/ExhibitorsPage';
import TabbedExhibitorPage from '../../exhibitors/pages/TabbedExhibitorPage';
import HomeVideo3DX from '../../home/pages/HomeVideo3DX';
import SplashScreen from '../../home/pages/SplashScreen/SplashScreen';
import IframePage from '../../iframe/IframePage';
import NetworkingRouter from '../../networking/NetworkingRouter';
import ParticipantsScreen from '../../participants/ParticipantsScreen';
import ProfilePage from '../../profile/pages/ProfilePage';
import { ProfileScreen } from '../../profile/Profile';
import SpeakersPage from '../../speakers/pages/SpeakersPage';
import Speaker from '../../speakers/Speaker';
import WorkshopSessionPage from '../../workshop-session/pages/WorkshopSessionPage';
import SessionPage from '../../workshops/pages/SessionPage';
import WorkshopPage from '../../workshops/pages/WorkshopPage';
import WorkshopSessionsPage from '../../workshops/pages/WorkshopSessionsPage';
import WorkshopsPage from '../../workshops/pages/WorkshopsPage';
import WorkshopLive from '../../workshops/WorkshopLive';
import NotificationsScreen from '../../notifications/NotificationsScreen';

export const routeComponents = {
  'agenda': AgendaPage,
  'cms': CmsPage,
  'cv-profile': ProfilePage,
  'data': DataPage,
  'exhibitor': ExhibitorPage,
  'exhibitor-group': RdvScreen,
  'exhibitor-tabbed': TabbedExhibitorPage,
  'exhibitors': ExhibitorsPage,
  'home-video-3dx': HomeVideo3DX,
  'iframe': IframePage,
  'matching': RdvOffersScreen,
  'notifications': NotificationsScreen,
  'participants': ParticipantsScreen,
  'profile': ProfileScreen,
  'session-page': SessionPage,
  'speaker': Speaker,
  'speakers': SpeakersPage,
  'splash-screen': SplashScreen,
  'workshop-live': WorkshopLive,
  'workshop-page': WorkshopPage,
  'workshop-session': WorkshopSessionPage, // Apec
  'workshop-sessions': WorkshopSessionsPage,
  'workshops': WorkshopsPage,
};

export const componentRouters = {
  networking: NetworkingRouter,
};
